/* A cart shortcut for the compact Studio member bar; native cart behavior stays intact. */
(() => {
  const studioSelector = '.fp-sticker-studio,.fp-banner-page:not(.fp-sign-page),.bbs,.fp-banner-display-studio,.fp-gang-entry,[data-fp-gang-studio],.fp-design-lab-studio,.fp-enhancer-studio,.fp-background-studio,.fp-big-head-studio,.fp-laser-studio,.fp-sign-studio,.fp-blanks-studio,.fp-blank-studio';
  const cardSelector = '.fp-membership-status__card--cart';
  let cartSource = null;
  let cartParent = null;
  let observer = null;
  const membershipCards = new WeakSet();

  function bindMembershipDestination() {
    const rootPath = window.Shopify?.routes?.root || '/';
    const membershipUrl = `${rootPath.replace(/\/?$/, '/')}pages/memberships`;
    document.querySelectorAll('[data-fp-membership-status]').forEach((root) => {
      root.dataset.membershipUrl = membershipUrl;
      root.dataset.membershipAccountUrl = membershipUrl;
      const card = root.querySelector('[data-fp-membership-card]');
      if (!card || membershipCards.has(card)) return;
      const update = () => {
        if (card.getAttribute('href') !== membershipUrl) card.setAttribute('href', membershipUrl);
      };
      update();
      new MutationObserver(update).observe(card, { attributes: true, attributeFilter: ['href'] });
      membershipCards.add(card);
    });
  }

  function updateCartCards() {
    const href = cartSource?.getAttribute('href') || '/cart';
    const count = cartSource?.querySelector('.cart-count-bubble [aria-hidden="true"]')?.textContent.trim() || '';
    const showCount = /^\d+\+?$/.test(count) && count !== '0';
    document.querySelectorAll(`.fp-membership-status ${cardSelector}`).forEach((card) => {
      card.setAttribute('href', href);
      card.setAttribute('aria-label', showCount ? `Open cart (${count} ${count === '1' ? 'item' : 'items'})` : 'Open cart');
      const badge = card.querySelector('[data-fp-studio-cart-count]');
      badge.textContent = showCount ? count : '';
      badge.hidden = !showCount;
    });
  }

  function bindCartCount() {
    const nextSource = document.getElementById('cart-icon-bubble');
    const nextParent = nextSource?.parentNode || null;
    if (nextSource !== cartSource || nextParent !== cartParent) {
      observer?.disconnect();
      observer = null;
      cartSource = nextSource;
      cartParent = nextParent;
      if (cartSource) {
        observer = new MutationObserver(bindCartCount);
        observer.observe(cartSource, { childList: true, subtree: true, characterData: true });
        // Shopify may replace the cart link rather than just its count.
        if (cartParent) observer.observe(cartParent, { childList: true });
      }
    }
    updateCartCards();
  }

  function initialize() {
    bindMembershipDestination();
    if (!document.querySelector(studioSelector)) {
      observer?.disconnect();
      observer = null;
      cartSource = null;
      cartParent = null;
      return;
    }
    document.querySelectorAll('.fp-membership-status .fp-membership-status__cards').forEach((nav) => {
      if (nav.querySelector(cardSelector)) return;
      const card = document.createElement('a');
      card.className = 'fp-membership-status__card fp-membership-status__card--cart';
      card.href = '/cart';
      card.setAttribute('aria-label', 'Open cart');
      card.innerHTML = '<svg class="fp-membership-status__card-icon" viewBox="0 0 64 64" aria-hidden="true" focusable="false"><path d="M7 10h7l7 31h29l7-23H17"></path><circle cx="26" cy="52" r="4"></circle><circle cx="47" cy="52" r="4"></circle></svg><span class="fp-membership-status__card-copy"><strong>Cart</strong></span><span class="fp-membership-status__cart-count" data-fp-studio-cart-count aria-hidden="true" hidden></span>';
      nav.appendChild(card);
    });
    bindCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
